import React from "react"

import { 
    Row, 
    Col, 
} from "react-bootstrap"

import "./style.css"

const EMETLPersonnelRow = (props) => {
    const { person: { Name, Rank }, select } = props

    return (
        <Row
            className="bg-light border-bottom personnelRow"
            onClick={select}
        >
            <Col>
                {Name}
            </Col>
            <Col>
                {Rank}
            </Col>
        </Row>
    )
}

export default EMETLPersonnelRow